import HistoryEntryWrapper from "components/Run/elements/HistoryEntryWrapper";
import HistoryEntryUsername from "components/Run/elements/HistoryEntryUsername";
import HistoryEntryLabel from "components/Run/elements/HistoryEntryLabel";

import { RunHistoryEntryType } from "../../types";

type ConfirmedEntryProps = {
  timestamp: number;
  until: number | null;
  username: string | null;
};

const ConfirmedEntry = ({ timestamp, until, username }: ConfirmedEntryProps) => {
  const label = (
    <HistoryEntryLabel>
      <strong>Confirmed</strong> <HistoryEntryUsername username={username} />
    </HistoryEntryLabel>
  );

  return (
    <HistoryEntryWrapper
      label={label}
      state={RunHistoryEntryType.Confirmed}
      timestamp={timestamp}
      until={until}
    />
  );
};

export default ConfirmedEntry;
